<template>
  <div>{{ name }}</div>
</template>

<script setup lang="ts">
import { inject, onMounted } from 'vue';
import { OverviewCategory } from '@/types';

const props = defineProps<OverviewCategory>();

const registerOverviewCategory = inject<(category: OverviewCategory) => undefined>('registerOverviewCategory');

onMounted(() => {
  registerOverviewCategory({ ...props });
})
</script>
